import { supabaseClient } from "supabase";

export const uploadImage = async (
  file: File,
  fileName: string,
  bucketName: string,
  folder: string
): Promise<string | null> => {
  const filePath = `${folder}/${fileName}`;

  await supabaseClient.storage.from(bucketName).upload(filePath, file);

  const { data } = supabaseClient.storage
    .from(bucketName)
    .getPublicUrl(filePath);

  return data!.publicUrl;
};
